<template>
  <div class="page-outbox" v-if="pakageInfo.so_no">
    <!--配货单号-->
    <div class="order-status">
      <label>配货单号：{{pakageInfo.dp_id}}</label>
    </div>
    <!--订单号-->
    <div class="order-status">
      <label>订单号：{{pakageInfo.so_no}}</label>
    </div>
    <!--快递公司-->
    <div class="order-status">
      <label>快递公司：{{pakageInfo.dp_express_com}}</label>
    </div>
    <div class="order-status">
      <label>快递单号：{{pakageInfo.dp_express_no}}</label>
    </div>
    <!--发货日期-->
    <div class="order-time">
      <label>发货日期：{{pakageInfo.dp_sendtime}}</label>
    </div>
    <!--订单日期-->
    <div class="order-time">
      <label>订单日期：{{pakageInfo.so_ctime}}</label>
    </div>
    <!--地址-->
    <div class="order-addr">
      <h3 class="block-title">收货地址</h3>
      <h3 class="addr-user"><label class="name">{{pakageInfo.so_ca_name}}</label><span class="telNum">{{pakageInfo.so_ca_mobile}}</span><span class="telNum">&nbsp;&nbsp;{{pakageInfo.so_ca_phone}}</span></h3>
      <p class="addr-area">
        <span class="area">{{pakageInfo.so_ca_province}}</span><span class="area">{{pakageInfo.so_ca_city}}</span>
        <span class="area">{{pakageInfo.so_ca_county}}</span><span class="area">{{pakageInfo.so_ca_street}}</span>
      </p>
    </div>
    <!--订单列表-->
    <div class="goods-list-box">
      <h3 class="block-title">货物信息</h3>
      <ul class="goods-list" v-if="pakageInfo.items&&pakageInfo.items.length">
        <li class="goods-list-item" v-for="(item,index) in pakageInfo.items">
          <div class="goods-item-conetn-left">
            <p>货号：{{item.p_code}}</p>
            <p>产品名称：{{item.p_cn_name}}</p>
            <p>浓度级别：{{item.p_level}}</p>
          </div>
          <p>x{{item.dpd_num}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import OrderItem from 'basic/orderItem/orderItem'
  export default {
    name: "packageDetail",
    data(){
      return{
        pakageInfo:{},
        orderStatusMap:['未审核','审核通过','审核通过','已取消'],
        orderTypeMap: [ '未付款','部分付款','全额付款'],
        invoiceTypeMap:['随货','月开','半月开','不开票']
      }
    },
    mounted(){
      this.getOrderDetail();
    },
    methods:{
      toDetail(item){
        //this.$router.push({path:'/GoodsDetail/'+item.id})
      },
      getOrderDetail(){
        this.$cHttp.post('dispatchs/detail',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          dp_id:this.$route.params.packageId,
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            this.pakageInfo=res.data;
          }else{
            this.$toast('暂无数据')
          }
        }).catch((msg)=>{
          this.$toast(msg);
        })
      }
    },
    components:{
      OrderItem
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
  .page-outbox{
    background-color: #eee;
  }
  .order-status{
    display: flex;
    padding: .15rem .1rem;
    margin-bottom: .01rem;
    font-size: .13rem;
    background-color: #fff;
    >label{
      color: #333;
    }
    >span{
      flex: 1;
      text-align: right;
      color:#0b8ef1;
    }
  }
  .order-time{
    display: flex;
    padding: .15rem .1rem;
    margin-bottom: .01rem;
    font-size: .13rem;
    background-color: #fff;
    >label{
      color: #333;
    }
  }
  .order-addr{
    padding: .1rem;
    margin-bottom: .01rem;
    background-color: #fff;
    .addr-user{
      font-size: .14rem;
      color: #333;
      line-height: .25rem;
      >label{
        padding-right: .1rem;
      }
    }
    .addr-area{
      font-size: .13rem;
      color: #999;
      line-height: .2rem;
      .area{
        padding-right: .04rem;
      }
    }
  }
  .order-invoice{
    padding: .1rem;
    margin-bottom: .01rem;
    background-color: #fff;
    .invoice-company,.invoice-info-item {
      font-size: .14rem;
      color: #333;
      line-height: .25rem;
      > label {
        padding-right: .1rem;
      }
    }
    .addr-area{
      font-size: .13rem;
      color: #999;
      line-height: .2rem;
      .area{
        padding-right: .04rem;
      }
    }
  }
  .block-title{
    padding-bottom:.05rem;
    font-size: .14rem;
    line-height: .14rem;
    color: $mainColor;
    opacity: .3;
    &:before{
      content: "";
      display: inline-block;
      vertical-align: bottom;
      margin-right: .05rem;
      width: 3px;
      height: .14rem;
      background-color: $mainColor;
    }
  }
  .goods-list-box{
    margin-bottom: .01rem;
    background-color: #fff;
    .block-title{
      padding: .12rem .1rem 0;
    }
    .goods-list-item{
      padding: .1rem;
      display: flex;
      align-items: center;
      font-size: .15rem;
      line-height: .22rem;
      color: #666;
      border-bottom: 1px dashed #eee;
      .goods-item-conetn-left{
        flex: 1;
      }
    }
  }
  .order-price{
    padding: .15rem .1rem;
    text-align: right;
    font-size: .14rem;
    color: #333;
    >span{
      font-size: .16rem;
      font-weight: bold;
      color: $mainColor;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/packageDetail/packageDetail.vue